(() => {
  function init(scope = document) {
    const heroes = [...scope.querySelectorAll('[data-hero-video]')];
    if (scope.matches?.('[data-hero-video]')) heroes.unshift(scope);
    heroes.forEach(hero => {
      if (hero.dataset.videoInitialized) return;
      hero.dataset.videoInitialized = 'true';
      const video = hero.querySelector('video');
      const poster = hero.querySelector('.zenhax-home-hero__image');
      const button = hero.querySelector('.zenhax-home-hero__video-toggle');
      const header = document.querySelector('.section-header');
      function syncHeader() {
        header?.classList.toggle('zenhax-header-after-hero', hero.getBoundingClientRect().bottom <= 0);
      }
      syncHeader();
      const connection = navigator.connection;
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      const mobile = matchMedia('(max-width: 749px)').matches;
      const source = mobile ? (video.dataset.mobileSrc || video.dataset.desktopSrc) : (video.dataset.desktopSrc || video.dataset.mobileSrc);
      let userPaused = motion.matches || !!connection?.saveData || ['slow-2g', '2g'].includes(connection?.effectiveType);
      let posterReady = false;
      let scheduled = false;
      let attached = false;
      let destroyed = false;
      const rect = hero.getBoundingClientRect();
      let inView = rect.bottom > 0 && rect.top < innerHeight;
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;
      function updateButton(playing) {
        button.hidden = false;
        button.dataset.playing = String(playing);
        button.setAttribute('aria-label', playing ? button.dataset.pauseLabel : button.dataset.playLabel);
      }
      function play() {
        if (destroyed || !attached || userPaused || !inView || document.hidden) return;
        video.muted = true;
        const playing = video.play();
        playing?.catch(() => { userPaused = true; updateButton(false); });
      }
      function attach() {
        scheduled = false;
        if (destroyed || userPaused || !posterReady || !inView || document.hidden || !source) return;
        if (!attached) {
          attached = true;
          hero.dataset.videoVariant = mobile ? 'mobile' : 'desktop';
          video.src = source;
          video.load();
        }
        play();
      }
      function schedule() {
        if (destroyed || scheduled || userPaused || !posterReady || !inView || document.hidden) return;
        if (attached) { play(); return; }
        scheduled = true;
        if ('requestIdleCallback' in window) requestIdleCallback(attach, { timeout: 1200 });
        else setTimeout(attach, 150);
      }
      function reveal() {
        if (destroyed || video.paused || video.readyState < 2) return;
        hero.classList.add('is-video-playing');
        updateButton(true);
      }
      video.addEventListener('playing', () => {
        if (userPaused || !inView || document.hidden) { video.pause(); return; }
        if ('requestVideoFrameCallback' in video) video.requestVideoFrameCallback(reveal);
        else reveal();
      });
      video.addEventListener('pause', () => updateButton(false));
      video.addEventListener('error', () => {
        hero.classList.remove('is-video-playing');
        userPaused = true;
        updateButton(false);
      });
      button.addEventListener('click', () => {
        if (!video.paused) { userPaused = true; video.pause(); }
        else { userPaused = false; attach(); }
      });
      function visibility() {
        if (document.hidden) video.pause();
        else schedule();
      }
      document.addEventListener('visibilitychange', visibility);
      let observer;
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(entries => {
          inView = entries[0].isIntersecting;
          syncHeader();
          if (!inView) video.pause();
          else schedule();
        }, { threshold: 0 });
        observer.observe(hero);
      }
      const decoded = poster?.decode ? poster.decode().catch(() => {}) : Promise.resolve();
      decoded.then(() => requestAnimationFrame(() => requestAnimationFrame(() => {
        if (destroyed) return;
        posterReady = true;
        updateButton(false);
        schedule();
      })));
      (hero.closest('.shopify-section') || hero).addEventListener('shopify:section:unload', () => {
        destroyed = true;
        video.pause();
        observer?.disconnect();
        document.removeEventListener('visibilitychange', visibility);
        header?.classList.remove('zenhax-header-after-hero');
      }, { once: true });
    });
  }
  init();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
